/**
 * Per-device UX preferences.
 *
 * The user / workspace identity now flows through ``AuthContext``
 * (sourced from ``GET /api/v1/auth/me``); the only legacy state this
 * module still owns is the per-device ``selected_app_id`` so a
 * returning user lands on the same app shell they last viewed.
 *
 * The ``URL query param`` shortcut from the IA-REDESIGN MVP is
 * retired — auth ships in ENG-AUTH-LOGIN-SIGNUP.
 */

const SELECTED_APP_KEY = "aiaso:selected_app_id";

function readStorage(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string | null) {
  if (typeof window === "undefined") return;
  try {
    if (value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch {
    /* swallow */
  }
}

export function getStoredSelectedAppId(): string | null {
  return readStorage(SELECTED_APP_KEY);
}

export function setStoredSelectedAppId(appId: string | null) {
  writeStorage(SELECTED_APP_KEY, appId);
}

/**
 * Per-user product-UI language preference (ENG-MULTILOCALE-FIRST-CLASS
 * Track I). localStorage-first per the ticket's persistence decision — a
 * per-user backend row is a fast-follow if cross-device sync is asked
 * for. Validation against the shipped catalog set lives in
 * `src/i18n/resolve.ts`; this module only stores the raw tag.
 */
const UI_LANGUAGE_KEY = "aiaso:ui_language";

export function getStoredUiLanguage(): string | null {
  return readStorage(UI_LANGUAGE_KEY);
}

export function setStoredUiLanguage(language: string) {
  writeStorage(UI_LANGUAGE_KEY, language);
}
